var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-item',{attrs:{"is-name-displayed":false}},[_c('v-btn',{nativeOn:{"click":function($event){return _vm.onTransitionApply.apply(null, arguments)}}},[_vm._v("Apply")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }